import React from 'react'

interface ExperienceItem {
  company: string
  position: string
  period: string
}

const experience: ExperienceItem[] = [
  {
    company: 'Ultra Technologies',
    position: 'Middle DevOps Engineer',
    period: 'July 2025 - Present'
  },
  {
    company: 'EchoHire',
    position: 'Founder',
    period: 'June 2025 - Present'
  },
  {
    company: 'Itransation Group',
    position: 'Full Stack Developer',
    period: 'December 2024 - February 2025'
  }
]

const ExperienceSection: React.FC = () => {
  return (
    <div className="experience-timeline">
      {experience.map((item, index) => (
        <div key={index} className="experience-item">
          <div className="experience-item-header">
            <div className="experience-info">
              <h3 className="company">{item.company}</h3>
              <p className="position">{item.position}</p>
            </div>
            <span className="period">{item.period}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default ExperienceSection